/** Задержка от запроса на открытие, до открытия */
export const ENTER_DELAY = 100;
/** Задержка от запроса на закрытие, до закрытия */
export const LEAVE_DELAY = 0;
/** Задержка по окончанию тапа, через которую подсказка закрывается */
export const LEAVE_TOUCH_DELAY = 1500;
/** Задержка от начала тапа, через которую подсказка открывается */
export const TOUCH_DELAY = 700;
/** Дополнительная задержка, в течение которой открытие новых тултипов происходит без задержки */
export const HYSTERSIS_DELAY = 800;